import { render } from "./FuturePastAppointments.vue?vue&type=template&id=7fac0634"
import script from "./FuturePastAppointments.vue?vue&type=script&lang=js"
export * from "./FuturePastAppointments.vue?vue&type=script&lang=js"

import "./FuturePastAppointments.vue?vue&type=style&index=0&id=7fac0634&lang=scss"

import exportComponent from "/var/local/jenkins-agent/data/agent/workspace/_Bitbucket_tvg-online-gui_master/tvg-online-ui/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__